<template>
  <div>
    <el-alert
      title="委托单提交成功，请尽快付款！"
      type="warning"
      show-icon>
      <span>委托单号：<span style="font-weight: bold">{{testEntrust.orderNo}}</span></span>
      <span style="margin-left: 30px;">应付金额：<span style="color: red;font-size: 20px;">{{testEntrust.sumPrice}}</span>元</span>
    </el-alert>
    <el-form v-if="payType === '2'" :model="paymentInfo" label-width="110px" size="small" style="margin-top: 10px;">
        <el-row style="width: 80%">
          <el-col :span="24">
            <el-form-item label="开户银行：">
              {{testInspectionOrgEdit.collectionBank}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="户名：">
              {{testInspectionOrgEdit.collectionName}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="银行账号：">
              {{testInspectionOrgEdit.collectionBankNo}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div>
          <el-row style="width: 80%">
            <el-col :span="24">
              <div style="margin-bottom: 20px">
                <span>转账成功后请上传转账凭证，审核通过后受理</span>
              </div>
              <div style="width:80%;display: inline-block; margin-right: 10px">
                <el-form-item label="">
                  <el-upload
                    class="upload-demo"
                    :headers="{'Authorization': 'Bearer ' + this.commonUtils.localStorageGet('token')}"
                    :action="imageUrl"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    v-loading="loading"
                    :show-file-list="false">
                    <el-button size="small" type="primary">上传支付凭证</el-button>
                  </el-upload>
                  <div style="line-height: 24px;margin-top: 10px;margin-left: 5px;">{{paymentInfo.fileName}}</div>
                  <!--<el-input style="width:400px;margin-top: 15px" v-model="paymentInfo.fileName" placeholder="文件名称" readonly></el-input>-->
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <!--<single-pic-upload style="margin-top: 20px" v-model="paymentInfo.filePath" uploadUrl="/testEntrust/uploadTransferVoucherFile.do"></single-pic-upload>-->
        </div>
    </el-form>
    <el-form v-if="payType === '0'" :model="paymentInfo" label-width="110px" size="small" style="margin-top: 10px;">
      <el-row style="width: 80%">
        <el-col :span="24">
          <el-form-item label="">
            <div style="width: 300px;text-align: center;">
              <img :src="paymentRet.qrcode">
              <el-button size="medium" type="text" @click="handleRefreshQrCode">刷新二维码</el-button>
              <div style="width: 300px;text-align: center;font-size: 28px;">
                <div>请用微信支付</div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form v-if="payType === '1'" :model="paymentInfo" label-width="110px" size="small" style="margin-top: 10px;">
      <el-row style="width: 80%">
        <el-col :span="24">
          <el-form-item label="">
            <div style="width: 300px;text-align: center;">
              <img :src="paymentRet.qrcode">
              <el-button size="medium" type="text" @click="handleRefreshQrCode">刷新二维码</el-button>
              <div style="width: 300px;text-align: center;font-size: 28px;">
                <div>请用支付宝支付</div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-divider></el-divider>
    <div class="clearfix" style="text-align: center">
      <el-button size="medium" type="warning" @click="handleBack">返回上一页</el-button>
      <el-button v-if="payType === '2'" size="medium" type="success" :loading ="loading" @click="handleSave">提交</el-button>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { getTestEntrustResponse, saveTransferVoucher, getTestEntrustById, refreshQrCode } from '@/api/test/entrust'

export default {
  name: 'payment-submit',
  props: {
    entrustId: {
      type: String,
      default: ''
    },
    paymentRetInfo: {
      type: Object
    }
  },
  data () {
    return {
      testInspectionOrgEdit: {},
      testEntrust: {},
      paymentRet: {},
      paymentInfo: {
        entrustId: '',
        filePath: '',
        fileName: ''
      },
      payType: '2', // 0 微信 1 支付宝 2 转账
      prevTid: '',
      loading: false,
      // imageUrl: '',
      imageUrl: (process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro) + '/testEntrust/uploadTransferVoucherFile.do'
    }
  },
  mounted () {
    if (this.paymentRetInfo) {
      this.payType = this.paymentRetInfo.payType
      this.paymentRet = this.paymentRetInfo
    }
    if (this.payType === '0') {
      this.prevTid = setInterval(this.getTestEntrustById, 3000)
    }
    if (this.payType === '1') {
      this.prevTid = setInterval(this.getTestEntrustById, 3000)
    }
    this.getTestEntrustResponse()
    this.paymentInfo.entrustId = this.entrustId
  },
  beforeDestroy () {
    clearInterval(this.prevTid)
  },
  methods: {
    beforeUpload () {
      this.loading = true
    },
    onError () {
      this.loading = false
    },
    handleAvatarSuccess: function (res, file, fileList) {
      if (res.rtnCode !== '0') {
        this.loading = false
        this.$message.error(res.msg)
        return false
      }
      this.paymentInfo.filePath = res.bizData.filePath
      this.paymentInfo.fileName = res.bizData.fileTitle
      this.loading = false
    },
    handleRefreshQrCode () {
      let param = { entrustId: this.entrustId }
      refreshQrCode(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData) {
            this.paymentRet = result.bizData
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('刷新二维码失败')
      })
    },
    getTestEntrustResponse () {
      let param = { entrustId: this.entrustId }
      getTestEntrustResponse(param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData.testInspectionOrgEdit) {
            this.testInspectionOrgEdit = result.bizData.testInspectionOrgEdit
          }
          if (result.bizData.testEntrust) {
            this.testEntrust = result.bizData.testEntrust
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    },
    handleBack () {
      if (this.prevTid) {
        clearInterval(this.prevTid)
      }
      this.$emit('back')
    },
    getTestEntrustById () {
      let param = { entrustId: this.entrustId }
      this.loading = true
      getTestEntrustById(param)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode === '0') {
            if (result.bizData.payStatus === '1') {
              clearInterval(this.prevTid)
              this.$message.success('支付成功！')
              this.$emit('next')
            } else if (result.bizData.payStatus === '2') {
              this.$message.success('支付失败！')
              this.$emit('back')
            }
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    },
    handleSave () {
      if (!this.paymentInfo.filePath) {
        this.$confirm('是否确认不上传支付凭证, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doSave()
        }).catch(() => {
        })
      } else {
        this.doSave()
      }
    },
    doSave () {
      saveTransferVoucher(this.paymentInfo)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'warning',
              message: result.msg
            })
          } else {
            if (this.prevTid) {
              clearInterval(this.prevTid)
            }
            this.$emit('next')
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('保存失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>

</style>
